<template>
    <h1>{{ $t("success.done") }}</h1>
    <div class="like-icon-container">
        <span class="icon-like"></span>
    </div>
    <transition name="bounce" appear>
        <div class="buttons-container">
            <RoundButton
                background="var(--secondary)"
                class="gohome-button"
                @click="$router.push('/')"
            >
                <span class="icon-fullscreen"></span>
                <span class="text-fullscreen">
                    {{ $t("success.seeMyVideoHome") }}
                </span>
            </RoundButton>
        </div>
    </transition>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import RoundButton from "@/components/buttons/RoundButton.vue";

export default defineComponent<{}>({
    name: "StandardProjectSuccess",
    components: {
        RoundButton
    }
});
</script>

<style scoped>
h1 {
    font-size: 3em;
    margin-top: 20px;
    margin-bottom: 20px;
    color: var(--screenTextColor);
}

.buttons-container {
    display: grid;
    grid-template-rows: 1fr 1fr;
}

.icon-like {
    font-size: 6em;
}

.like-icon-container {
    margin-top: 20px;
    margin-bottom: 40px;
    animation: rotateAndGrow 1s ease-out;
    color: var(--screenTextColor);
}

.goar-button,
.gohome-button {
    color: var(--buttonTextColor);
    font-weight: 500;
    margin-top: 10px;
    margin-bottom: 10px;
}

.icon-fullscreen,
.icon-view_in_ar {
    font-size: 1.8em;
    margin-right: 5px;
}

.text-fullscreen,
.text-ar {
    flex-grow: 1;
}

@keyframes rotateAndGrow {
    0% {
        transform: rotate(0deg) scale(0.01);
    }
    100% {
        transform: rotate(360deg) scale(1);
    }
}
</style>
